module.exports = __webpack_public_path__ + "img/testCasePass.c0a629c6.svg";